import React, { memo, PropsWithChildren } from 'react';

import { cn } from '@nextui-org/react';

interface ITypoProps extends PropsWithChildren {
	size?: 10 | 12 | 14 | 16 | 18 | 20 | 24 | 28 | 32 | 36 | 40 | 60 | 64 | 80;
	weight?: 'normal' | 'medium' | 'semi' | 'bold' | 'black';
	as?: keyof JSX.IntrinsicElements;
	title?: string;
	className?: string;
	dataAos?: string;
}

const DEFAULT_CLASS = '';

const sizeMap = {
	10: 'text-[10px] leading-[14px]',
	12: 'text-[12px] leading-[18px]',
	14: 'text-[14px] leading-[22px]',
	16: 'text-[16px] leading-[24px]',
	18: 'text-[18px] leading-[28px]',
	20: 'text-[20px] leading-[30.92px]',
	24: 'text-[24px] leading-[37.1px]',
	28: 'text-[28px] leading-[43.29px]',
	32: 'text-[32px] leading-[49.47px]',
	36: 'text-[36px] leading-[56px]',
	40: 'text-[40px] leading-[62px]',
	60: 'text-[60px] leading-[94px]',
	64: 'text-[64px] leading-[100px]',
	80: 'text-[80px] leading-[126px]',
};

const weightMap = {
	normal: 'font-normal',
	medium: 'font-medium',
	semi: 'font-semibold',
	bold: 'font-bold',
	black: 'font-black',
};

const ITypo: React.FC<ITypoProps> = ({
	size = 16,
	weight = 'normal',
	as: Component = 'span',
	className = '',
	title,
	children,
	dataAos,
}) => {
	const sizeClass = sizeMap[size];
	const weightClass = weightMap[weight];

	return (
		<Component
			title={title}
			className={cn(DEFAULT_CLASS, sizeClass, weightClass, className)}
			data-aos={dataAos}
		>
			{children}
		</Component>
	);
};

export default memo(ITypo);
